import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  model,
  output,
  Signal,
  viewChild,
} from '@angular/core';
import { DsBoxModule, DsModalModule } from '@bmw-ds/components';

import { Customer } from '../../customer/model/customer.model';
import { FoundRetailCustomer } from '../../customer/model/found-customer.model';
import { useI18n } from '../../i18n/services/i18n.service';
import { PaginationProvider } from '../../utils/pagination/pagination.provider';
import { modalOpenOrClosing } from '../../utils/signal/modalOpenOrClosing';
import { CustomerCreationModalContainer } from './customer-creation-modal.container';

@Component({
  selector: 'cdf-customer-creation-modal-wrapper',
  imports: [DsBoxModule, DsModalModule, CustomerCreationModalContainer],
  providers: [PaginationProvider],
  template: `
    <ds-modal [ds-modal-trigger-for]="modal" [(isModalOpen)]="open" [isDismissable]="false" #modal>
      <ds-box-header>
        {{ i18n('customerCreation.heading') }}
        <span class="text-regular text-neutral d-inline">({{ paginationProvider.stepString() }})</span>
      </ds-box-header>
      <ds-box-content>
        @if (openOrClosing()) {
          <cdf-customer-creation-modal
            [initialCustomerInfo]="initialCustomerInfo()"
            (closeModal)="open.set(false)"
            (openCustomerProfile)="openCustomerProfile.emit($event)"
          />
        }
      </ds-box-content>
    </ds-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerCreationModalWrapper {
  protected readonly i18n = useI18n();
  protected readonly paginationProvider = inject(PaginationProvider);

  readonly open = model(false);
  readonly initialCustomerInfo = input<Customer>();

  readonly openCustomerProfile = output<FoundRetailCustomer>();

  readonly modal: Signal<ElementRef<HTMLElement>> = viewChild.required('modal', { read: ElementRef });

  protected readonly openOrClosing = modalOpenOrClosing(this.open, this.modal);
}
